// This is just an example,
// so you can safely delete all default props below

export default {
    change_password: 'Change password',
    current_password: 'Current password',
    new_password: 'New password',
    repeat_password: 'Repeat password',
    error_current_password: 'Current password must be supplied.',
    error_new_password: 'The password must be at least 8 characters, and must contain uppercase / lowercase letters, numbers and symbols.',
    error_repeat_password: 'Password repeat must be the same as new password.',
    error_worng_current_password: 'Current password is not valid.',
    succeeded: 'Your password have now been changed successfully.',
    failed: 'An error occurred.'
}
